import Vue from 'vue'
import App from './App.vue'
import router from "./utils/router";
import {get,post,apiHost,upload} from "./utils/request";
import {Field, RadioGroup,Radio,Button,Switch,Image,Uploader,Popup,Cell,CellGroup,NoticeBar,Picker,Tag,Loading,Toast,Dialog,List,Icon,ImagePreview,NavBar,Empty,Grid,GridItem,Area} from 'vant';
import 'vant/lib/index.css';

Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Image);
Vue.use(Uploader);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(NoticeBar);
Vue.use(Picker);
Vue.use(Loading);
Vue.use(Tag);
Vue.use(List);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Empty);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Area);


Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$imagePreview = ImagePreview;


Vue.config.productionTip = false

export function formatDate(val,format){
	if (!val) {
		return '';
	}
	  // 如果时间戳后不是毫秒值就加000,变成毫秒值
	if (val && val.length != 13) {
		if (val && val.length == 10) {
			val = parseInt(val+'000');
		};
		for (var i = 0; i < 13; i++) {
		  if (val.length === i) {
			val = parseInt(val*(10^(13-i)));
		  }
		}
	}
	  
	var date = new Date(+val);
	var o = {   
		"M+" : date.getMonth()+1,                 //月份   
		"d+" : date.getDate(),                    //日
		"h+" : date.getHours(),                   //小时   
		"m+" : date.getMinutes(),                 //分   
		"s+" : date.getSeconds(),                 //秒   
		"q+" : Math.floor((date.getMonth()+3)/3), //季度   
		"S"  : date.getMilliseconds()             //毫秒   
	};   
	if(/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
	}            
	for(var k in o) {
		if(new RegExp("("+ k +")").test(format)) {
			format = format.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
		}  
	}
	return format;
};

Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$upload = upload;
Vue.prototype.$apiHost = apiHost;
Vue.prototype.$formatDate = formatDate;

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
